import { render, staticRenderFns } from "./StartDay.vue?vue&type=template&id=53f638d9"
import script from "./StartDay.vue?vue&type=script&lang=js"
export * from "./StartDay.vue?vue&type=script&lang=js"
import style0 from "./StartDay.vue?vue&type=style&index=0&id=53f638d9&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports